import { EnApi } from '@core/api/enums/api.enums';

export const ARTICLES_URL: string = `${EnApi.CMS_API_TAG}/articles`;

export const PLUGINS_URL: string = `${EnApi.CMS_API_TAG}/plugins`;
